var React = require('react');
var createReactClass = require('create-react-class');
var PropTypes = require('prop-types');

var FoundationSlider = createReactClass({
	displayName: 'FoundationSlider',

	propTypes: {
		maxValue: PropTypes.number.isRequired,
		minValue: PropTypes.number.isRequired,
		value: PropTypes.number.isRequired,
		step: PropTypes.number.isRequired,
		onSliderChange: PropTypes.func.isRequired,
		onSliderInputChange: PropTypes.func.isRequired,
		id: PropTypes.string.isRequired,
	},

	handleSliderChange: function (event) {
		event.preventDefault();
		event.stopPropagation();
		var sliderValue = parseInt(this.sliderValueInput.value) || this.props.maxValue;
		this.props.onSliderChange(sliderValue);
	},

	componentDidMount: function () {
		var sliderId = "#" + this.props.id;
		$(sliderId).foundation().on("changed.zf.slider", this.handleSliderChange);
	},

	handleSliderInputChange: function (event) {
		this.props.onSliderInputChange(this.sliderValueInput.value);
	},

	handleSliderInputBlur: function(event) {
		var sliderValue = parseInt(this.sliderValueInput.value) || this.props.minValue;
		this.props.onSliderChange(sliderValue);
	},

	render() {
		return (
			<div className="row">
				<div className="small-8 columns">
					<div className="slider" data-slider data-initial-start={this.props.value} data-start={this.props.minValue} data-end={this.props.maxValue} data-step={this.props.step} id={this.props.id} data-changed-delay={500}>
						<span className="slider-handle"  data-slider-handle role="slider" tabIndex="1" aria-controls="sliderOutput1"></span>
						<span className="slider-fill" data-slider-fill></span>
					</div>
				</div>
				<div className="small-4 columns">
					<input type="text" id="sliderOutput1" onChange={this.handleSliderInputChange} ref={(ref) => this.sliderValueInput = ref} value={this.props.inputValue} onBlur={this.handleSliderInputBlur} maxLength="3"/>
				</div>
			</div>
    	);
}
});

module.exports = FoundationSlider;